module.exports = __webpack_public_path__ + "media/images/country_flags/vi-df1bffdfe78e55d630551aaedd8bbfc7.png";